contentProfiles.$inject = ['$http', '$q', 'configuration']

export default function contentProfiles($http, $q, config) {
  var _endPoint = config.apiEndPoint
  var _profiles = null

  return {
    getContentProfiles: () => {
      let deferred = $q.defer()

      if (_profiles) {
        deferred.resolve(_profiles)
      } else {
        console.info('Fetching content profiles')
        $http.get(`${_endPoint}/content_profile/profiles`).then(
          response => {
            _profiles = response.data
            deferred.resolve(_profiles)
          },
          response => deferred.reject(response.data)
        )
      }
      return deferred.promise
    }
  }
}
